








































































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Picture } from '../components';
import { Message, Cancellation } from './components';
import { RouteParsedMixin } from '../../../mixins';
import { IPurchasesItems, IPurchasesCard } from './types';
import { routeParse } from '@/pages/profile/utils';

@Component({
  components: {
    Picture,
    Message,
    Cancellation,
  },
})
export default class PurchasesCard
  extends Mixins(RouteParsedMixin)
  implements IPurchasesCard
{
  @Prop({ type: Object, required: true })
  readonly items!: IPurchasesItems;

  get statusColorClass(): string {
    const { variant } = this.items;
    return `card__status_${variant}`;
  }

  routerRequest(val: IPurchasesItems) {
    const id = val.orderId;
    const name = 'new-program';
    const router = routeParse(id, '', name);
    return router;
  }

  routerActivity(val: IPurchasesItems) {
    const id = val.activity_id;
    const name = 'activity';
    const router = routeParse(id, '', name);
    return router;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/cards/purchases/Purchases.vue